import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroBadges, heroStats, images } from '../data/salesCopy';
export function Hero() {
  return <section className="w-full border-b border-line bg-paper" data-id="element-112" data-mp="9ll8uwe5pwmz">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-5 sm:py-14 lg:py-20" data-id="element-113" data-mp="4lyswf6y22ah">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-114" data-mp="4jvyliyrdmzy">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-115" data-mp="xae8p3xwgomv">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-116" data-mp="sd4d16jx3gql">
              TeachersKit™
            </p>
            <h1 className="mt-3 font-display text-[2rem] font-semibold leading-[1.08] tracking-tight text-ink sm:mt-4 sm:text-5xl lg:text-[3.5rem]" data-id="element-117" data-mp="3d2lapfhgtb2a">
              Stop wasting your Sundays planning lessons.
            </h1>
            <p className="mt-4 max-w-xl font-display text-lg font-medium leading-snug text-rust sm:mt-5 sm:text-2xl" data-id="element-118" data-mp="3j9247l4e1kty">
              The all-in-one “Print &amp; Go” system for piano and guitar teachers.
            </p>
            <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-ink-soft sm:mt-5 sm:text-lg" data-id="element-119" data-mp="39cfk4yjvyxsz">
              Get 300+ pages of ready-to-print exercises, structured lesson plans, and studio tools.
              Everything is PDF — no videos, no audiobooks — and it lands in your email the moment
              you buy.
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-y-2 sm:mt-8 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-120" data-mp="2qkda461r2frp">
              {heroBadges.map(badge => <li key={badge} className="flex items-center gap-2 text-[13px] font-medium text-ink sm:text-sm" data-id="element-121" data-mp="2vj7s55rw80ar">
                  <CheckIcon className="h-4 w-4 shrink-0 text-rust" aria-hidden="true" data-id="element-122" data-mp="2ljpa4uvjmolc" />
                  {badge}
                </li>)}
            </ul>

            <div className="mt-7 sm:mt-9" data-id="element-123" data-mp="nbl58stuaue5">
              <CtaButton size="large" placement="hero" label="Yes! I want the bundle — access now for $19" mobileLabel="Get the bundle for $19" note="Safe & secure checkout · PDFs sent by email · 30-day guarantee" data-id="element-124" data-mp="naji3pzjuhg2" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.55,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative" data-id="element-125" data-mp="161szsmjh4ciq">
            <img src={images.heroMockup} alt="A tablet showing a printed piano exercise worksheet, surrounded by stacks of printed lesson sheets on a desk" className="w-full rounded-2xl border border-line object-cover shadow-lift" data-id="element-126" data-mp="x0crqlg4smho" />
            <div className="absolute -bottom-3 left-3 rounded-full border border-line bg-surface px-3 py-1.5 text-[11px] font-semibold text-ink shadow-lift sm:-bottom-4 sm:left-6 sm:px-4 sm:py-2 sm:text-xs" data-id="element-127" data-mp="1xaceczu3ndrn">
              6 volumes · Print unlimited copies
            </div>
          </motion.div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-6 border-t border-line pt-7 sm:mt-16 sm:gap-8 sm:pt-8 md:grid-cols-4" data-id="element-128" data-mp="2b1hjghg8ky9d">
          {heroStats.map(stat => <div key={stat.label} data-id="element-129" data-mp="2kyndnyk5d5dt">
              <dt className="sr-only" data-id="element-130" data-mp="2kxki3dbvqerk">{stat.label}</dt>
              <dd data-id="element-131" data-mp="2p0qockyzs5y1">
                <span className="block font-display text-xl font-semibold leading-none text-ink sm:text-3xl" data-id="element-132" data-mp="2p08tnsrz9zs8">
                  {stat.value}
                </span>
                <span className="mt-2 block text-xs leading-snug text-ink-muted sm:text-sm" data-id="element-133" data-mp="2tx7ka1cfnolo">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}